// extracted by mini-css-extract-plugin
export default {"overlay":"custom-popup_overlay__E61Iw","popup":"custom-popup_popup__FZuVX","close":"custom-popup_close__egGLG","content":"custom-popup_content__4Ol21"};